

import React from 'react';
import { connect } from 'react-redux';
import { Button, Input } from 'reactstrap';
// import ApuaWhiteTextLogo from '../../ImageAssets/Apua_New_Logo.png';
// import ApuaWhiteTextLogo from '../../ImageAssets/ApuaWhiteTextLogo.png';
import { setLoginPage, setUserRegisterDetails } from '../../General/Actions';

import blueBanner from '../../ImageAssets/blueBanner.png';
import ApuaWhiteTextLogo from '../../ImageAssets/Apua_New_Logo_White.png';

import { FaArrowRight, FaArrowLeft } from 'react-icons/fa';
import Network from '../../Utils/network.js';
import ValidateForm from '../../Utils/formValidation';
import LoadingAnimation from '../../Utils/loadingAnimation.js';
import Swal from 'sweetalert2';

class RegisterFirstStepComponent extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoading: false,
            serviceId: ""
        }
    }

    componentDidMount() {
        this.updateWindowDimensions();
        window.addEventListener('resize', this.updateWindowDimensions);
    }

    updateWindowDimensions = () => {
        this.setState({ windowWidth: window.innerWidth, windowHeight: window.innerHeight });
    }

    inputValueChange(name, value) {
        this.setState({
            [name]: value
        })
    }

    loginButtonClicked() {
        this.props.setLoginPage("pageName", "login");
    }
    arrowIconClicked() {
        this.props.setLoginPage("pageName", "login");
    }

    gotoOtpPage() {
        if (ValidateForm.inputFieldMandatoryCheck("registerFirstStepContainer", this.props.locales, false)) {
            if (ValidateForm.inputFieldValueCompositionCheck("registerFirstStepContainer", this.props.locales, false)) {
                this.setState({ isLoading: true })
                var currentService = {}
                var isSharedAccount = false;
                var isParent = false;
                var connectionType = "";
                Network.executeAxios("fetchServiceInfoForPWL", "POST", { "serviceId": this.state.serviceId }, (fetchServiceInforesponse) => {
                    if (fetchServiceInforesponse && fetchServiceInforesponse.BillingSystem && fetchServiceInforesponse.BillingSystem.response &&
                        fetchServiceInforesponse.BillingSystem.response.dataset && fetchServiceInforesponse.BillingSystem.response.dataset.service_info) {
                        currentService = fetchServiceInforesponse.BillingSystem.response.dataset.service_info[0]
                    }
                    if (currentService && currentService.is_shared_account && currentService.is_shared_account === "1") {
                        isSharedAccount = true;
                    }
                    if (currentService && currentService.is_parent && currentService.is_parent === "1") {
                        isParent = true;
                    }
                    if (currentService && currentService.connection_type) {
                        this.props.setUserRegisterDetails("connectionType", currentService.connection_type);
                    } 

                    if(currentService && currentService.status && currentService.status === this.props.locales.terminateStatusIdFromBilling){
                        this.setState({ isLoading: false })
                        Swal.fire(this.props.locales.terminateSwalMsgInSignUp)
                    } else if(isSharedAccount && isParent == false){
                        this.setState({ isLoading: false })
                        Swal.fire(this.props.locales.plsContactCustomerSupportSwalmsg)
                    } else {
                        var profileId = ""
                        if (currentService && currentService.profile_id) {
                            profileId = currentService.profile_id
                        }
                        Network.executeAxios("duplicateProfileIdCheck", "POST", { "profileId": profileId }, (duplicateUsernameCheckResponse) => {
                            if (duplicateUsernameCheckResponse.STATUS === "PROFILE_ID_ALREADY_EXIST") {
                                //Toast.showToast("Duplicate Profile ID Found");
                                this.setState({ isLoading: false })
                                Swal.fire(this.props.locales.duplicateCustomerIdInSwal);
                            } else {
                                // if(valid customer id)
                                if (isSharedAccount && isParent == false) {
                                    this.setState({isLoading: false})
                                    Swal.fire(this.props.locales.plsContactCustomerSupportSwalmsg)
                                } else {
                                    if (currentService.profile_info && currentService.profile_info[0]) {
                                        var params = currentService.profile_info[0];
                                        var profileContactEmail = "";
                                        // var profileContactNumber = "";
                                        // if (params && params.contact_number_1) {
                                        //     profileContactNumber = params.contact_number_1
                                        // }
                                        if (params && params.contact_email_id) {
                                            profileContactEmail = params.contact_email_id
                                        }
                                        this.props.setUserRegisterDetails("email", profileContactEmail);
                                        var generatedOtp = Math.floor(Math.random() * 90000) + 10000;
                                        var dataToSendForOtp = {
                                            otp: generatedOtp,
                                            contactNum: this.state.serviceId
                                        }
                                        Network.executeAxios("otpAuth", "POST", dataToSendForOtp, (responseForOtp) => {
                                            if (responseForOtp.result_code && responseForOtp.result_code === "0") {
                                                this.props.setUserRegisterDetails("customerId", profileId);
                                                this.props.setUserRegisterDetails("profileContactNumber", this.state.serviceId);
                                                this.props.setUserRegisterDetails("generatedOtp", generatedOtp);
                                                this.props.changeCurrentRegisterPartTo("registerOtp");
                                            } else {
                                                Swal.fire(this.props.locales.internalErrorInForgetPwdPageSwal, "", "");
                                                this.setState({ isLoading: false })
                                            }
                                        });
                                    } else {
                                        Swal.fire(this.props.locales.customerIdInSwal, "", "");
                                        this.setState({ isLoading: false })
                                    }
                                }
                            }
                        });
                    }
                })
            }
        }
    }

    render() {
        return (
            <div>
                <div id="toastPopup" className="animated slideInRight d-none"></div>
                {this.state.isLoading ? <LoadingAnimation isVisible={true} /> : null}
                {this.componentContent()}
            </div>
        );
    }

    componentContent() {
        const registerFirstStepOuterMainContainerStyle = { height: (this.state.windowHeight) + 'px', display: "flex", flexDirection: "column" };
        return (
            <div style={registerFirstStepOuterMainContainerStyle}>
                <div className='p-5' style={{  backgroundImage: `url(${blueBanner})`,backgroundRepeat:"no-repeat",backgroundSize:"100% 100%"}}>
                    <div className="col-md-6 pb-5"><img alt="" src={ApuaWhiteTextLogo} /></div>
                </div>
                <div className="loginPageLeftPart col-md-3 row m-0 p-0 mx-auto " style={{ height: 'inherit', alignItems: 'center'}}  id="registerFirstStepContainer">
                    <div className="col-md-12" style={{}}>
                        <Input type="text" autoComplete="new-password" className="loginCredItem py-4"
                            placeholder={this.props.locales.enterServiceIdLabel} maxLength={10}
                            value={this.state.serviceId}
                            style={{ color: '#404042', fontWeight: 500 }}
                            // onKeyUp={(event) => this.displayLabel(event, this.state.username, this.props.locales.loginPageEmailPlcText)}
                            onChange={(event) => this.inputValueChange("serviceId", event.target.value)}
                        />
                        <div style={{ marginTop: 40 }}>
                        <div className="forgetLabel col-md-12 text-center p-0 mb-2" onClick={() => { this.loginButtonClicked() }}>
                        {this.props.locales.singInOptionTextInSignInWithOtpPart}
                            </div>
                        <div className="col-md-12 d-flex align-items-center justify-content-center" >
                            <div className="col-md-8 loginPageLoginButton p-3" onClick={() => {  this.gotoOtpPage() }}>
                             Next
                            </div>
                        </div>
                        </div>
                    </div>
                </div>
                {/* <div className="loginPageLeftPart col-10 col-md-3 row m-0 p-0 pt-md-5 mx-auto " style={{ height: 'inherit', alignItems: 'center', }}>
                    <div style={{flex:1}}>
                        <Input type="text" autoComplete="new-password" className="loginCredItem py-4"
                            placeholder={"Enter Service ID"}
                            value={this.state.username}
                            style={{ color: '#404042', fontWeight: 500 }}
                            // onKeyUp={(event) => this.displayLabel(event, this.state.username, this.props.locales.loginPageEmailPlcText)}
                            onChange={(event) => {}}
                        />

                         <div className="col-md-12 d-flex align-items-center justify-content-center" style={{ marginTop: 40 }}>
                            <div className="col-md-8 loginPageLoginButton p-3" onClick={() => {  this.gotoOtpPage() }}>
                             Next
                            </div>
                        </div>
                    </div>

                   
                </div> */}
               
              {/*  <div className="row m-0" style={{ flex: 1 }}>
                    <div className="col-md-6 p-0 d-none d-sm-block" >
                        <div className="leftPartBackgroundImage" style={{ display: "flex", flexDirection: "column", height: "100%", flex: 1, alignItems: "center", justifyContent: "center", background: `url(${Background}) 20%`, backgroundSize: 'cover' }}>
                            {this.loginPartComponent()}
                        </div>
                    </div>
                    <div className="col-md-6 p-0" >
                        <div style={{ display: "flex", height: "100%", flex: 1, justifyContent: "center", backgroundColor: '#ffffff' }}>
                            {this.registerFirstStepPartComponent()}
                        </div>
                    </div>
                </div>
                 */}
            </div> 
        )
    }


    registerFirstStepPartComponent() {
        return (
            <div className="loginPageLeftPart col-md-12 row p-0 m-0">
                <div className="loginPageLeftPart col-md-12 row p-0 m-0">
                    <div className="d-none d-sm-block d-md-none d-block col-md-12 p-0">
                        <div className="row col-md-12 m-auto py-2 px-2" style={{ backgroundColor: '#0285CA' }}>
                            <div className="col-md-12"><FaArrowLeft color="#fafafa" size="16" onClick={() => this.arrowIconClicked()} /> <img alt="" src={ApuaWhiteTextLogo} height="60" /></div>
                        </div>
                    </div>
                    <div className="col-md-12 row my-3 m-0 d-none d-sm-block">

                    </div>

                </div>

                <div className="col-md-12 row m-0 px-sm-3 px-0">
                    <div className="col-md-1"></div>
                    <div className="col-md-11" id="registerFirstStepContainer">
                        <div className="col-md-12" style={{ fontSize: 30, color: '#404042', fontWeight: 400 }}>{this.props.locales.registerFirstStepConfirmDetailsTxt}</div>
                        <div className="col-md-12 pb-4" style={{ fontSize: 14, color: '#404042' }}>{this.props.locales.registerFirststepCustomerIdTxt} <span style={{ fontWeight: 500 }}>{this.props.locales.registerFirstStepIPTxt}</span></div>
                        <div className="col-md-9 p-0">
                            <div className="form-group col-md-12" >
                                <label className="d-none animated slideInUp m-0" style={{ color: '#a3b4bc', fontSize: 12, position: 'absolute' }}>{this.props.locales.registerFirstStepCustomerIDLabel}</label>
                                <Input maxLength={10} type="text" name="serviceId" autoComplete="new-password" style={{ color: '#404042' }}
                                    className="loginCredItem input_data mandatoryFieldSpecial typeNumber pt-4 pb-3" placeholder={this.props.locales.registerFirstStepCustomerIDPlc}
                                    onChange={(event) => this.inputValueChange("serviceId", event.target.value)}
                                    onKeyUp={(event) => this.displayLabel(event, this.state.serviceId, this.props.locales.registerFirstStepCustomerIDPlc)} />
                                <div className="errorDesc" style={{ color: 'red', fontSize: 12, fontWeight: 400, position: 'absolute' }}></div>
                            </div>
                            {/* <div className="col-md-12 pt-3 pb-4">
                                <Reaptcha size="normal" sitekey={this.props.siteKey.siteKey} onVerify={this.onVerify} />
                            </div> */}
                            <div className="col-md-12 pt-3">
                                <Button className="loginPageLoginButton" onClick={() => { this.gotoOtpPage() }} disabled={this.state.serviceId === "" ? true : false}>
                                    {this.props.locales.registerFirstStepNextBtn}&nbsp; <FaArrowRight />
                                </Button>
                            </div>
                            {/* <div className="col-md-12 mt-3" style={{fontSize:13,fontWeight:'bold',cursor:'pointer',color:'#E21736'}}
                            onClick={() => {this.forgetUserNameOtpSentToEmailTryAnotherWay()}}>
                                {this.props.locales.forgetUserNameOTPTryAnotherWayTxt}
                        </div> */}
                        </div>
                        {/* <div className="d-flex pt-3 col-md-9 justify-content-center pb-5 mb-5 d-none">
                        <div style={{ color: '#0285CA', fontSize: 16, fontWeight: 'bold', cursor: 'pointer' }} onClick={() => { this.signInWithOTPLinkClicked() }}>{this.props.locales.signInUsingOtpLink}</div>
                    </div> */}
                    </div>
                    <div className="col-md-2"></div>
                </div>
            </div>
        )
    }

    loginPartComponent() {
        return (
            <div className=" col-md-12 row m-0 d-flex flex-column" style={{ height: '100%' }}>
                <div className="col-md-12 row pt-5 m-0" style={{ flex: 1 }}>
                    <div className="col-md-1"></div>
                    <div className="col-md-6 pl-5 ml-3"><img alt="" src={ApuaWhiteTextLogo} /></div>
                    <div className="col-md-5"></div>
                </div>
                <div className="col-md-12 row p-0 m-0 " style={{ flex: 4, alignItems: 'center' }}>
                    <div className="col-md-1"></div>
                    <div className="loginPageLeftPart col-md-9" >
                        <div className="col-md-12  pl-5" style={{ marginTop: '-100px' }}>
                            <div className="mb-1 col-md-12" style={{ fontSize: 32, color: '#ffffff', fontWeight: 300 }}>{this.props.locales.registerFirstStepAlreadyHvAccountTxt}</div>
                            <div className="mb-5 pb-4 col-md-12" style={{ fontSize: 16, color: '#ffffff', fontWeight: 300 }}>{this.props.locales.registerFirstStepSignInHereTxt}</div>
                            <div className="col-md-12 " style={{ marginTop: 50 }}>
                                <Button className="loginPageRegisterButton" style={{ fontSize: 24, fontWeight: 500 }} onClick={() => { this.loginButtonClicked() }}>
                                    {this.props.locales.registerFirstStepSignInBtn}
                                </Button>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-2"></div>
                </div>
            </div>
        )
    }

    displayLabel(event, value, placeHolderText) {
        if (value != "") {
            event.target.previousSibling.classList.remove('d-none');
            event.target.placeholder = "";
        } else {
            event.target.previousSibling.classList.add('d-none');
            event.target.placeholder = placeHolderText;
        }
    }

}
const mapStateToProps = (state, ownProperties) => {
    return {
        locales: state.locales,
        userRegisterDetails: state.userRegisterDetails,
        siteKey: state.siteKey
    }
}
function mapDispatchToProps(dispatch) {
    return {
        setLoginPage: function (key, payload) {
            dispatch(setLoginPage(key, payload));
        },
        setUserRegisterDetails: function (key, payload) {
            dispatch(setUserRegisterDetails(key, payload))
        }
    }
}

const RegisterFirstStepComponentContainer = connect(
    mapStateToProps,
    mapDispatchToProps
)(RegisterFirstStepComponent)


export default RegisterFirstStepComponentContainer;
